import { CartographerPage } from '../components/ProductPages';
import { publicMeta } from './public-meta';

export const meta = publicMeta(
  'Cartographer | Cartwheel',
  'Cartographer retargets captured and generated motion to 3D characters, robots, and avatars, with automatic rig mapping.',
);

export default CartographerPage;
